import {css, unsafeCSS} from "lit";
import {sbkCoreBreakpointMd, sbkCoreBreakpointLg} from '@/tokens/variables.js'

const breakpointMd = unsafeCSS(`${sbkCoreBreakpointMd}`);
const breakpointLg = unsafeCSS(`${sbkCoreBreakpointLg}`);

export const style = css`
  ul {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: left;
    gap: var(--sbkFooterSmallScrReducedLinkContainerGap);
    list-style-type: none;
    margin-block-start: 0;
    margin-block-end: 0;
    padding-inline-start: 0;
  }

  @media screen and (min-width: ${breakpointMd}) {
    ul {
      flex-direction: row;
      gap: var(--sbkFooterLargeScrReducedLinkContainerGap);
    }
  }

  @media screen and (min-width: ${breakpointLg}) {
    ul {
      justify-content: center;
    }
  }
`;
